
const overlay = document.querySelector('#cross-popup-overlay');
const popup = document.querySelector('#cross-popup');
const close = document.querySelector('#cross-popup-close');
const cart = document.querySelector('#cart-btn');
const scrollTrigger = 100;
const isMobile = window.matchMedia("(max-width: 767px)").matches;
const isCrossellDebug = new URLSearchParams(window.location.search).has('debug');

function triggerCrossellAddToCartHaptic() {
  const successPattern = 'success';

  if (window.__manaHaptics && typeof window.__manaHaptics.trigger === 'function') {
    window.__manaHaptics.trigger(successPattern);
    return;
  }

  if (window.__manaHapticsLoading && typeof window.__manaHapticsLoading.then === 'function') {
    window.__manaHapticsLoading.then((haptics) => {
      if (haptics && typeof haptics.trigger === 'function') {
        haptics.trigger(successPattern);
      } else if (navigator && typeof navigator.vibrate === 'function') {
        navigator.vibrate([25, 55, 35]);
      }
    });
    return;
  }

  if (navigator && typeof navigator.vibrate === 'function') {
    navigator.vibrate([25, 55, 35]);
  }
}

function crossellDebugConsole(method, ...args) {
  if (!isCrossellDebug || !window.console || typeof window.console[method] !== 'function') return;
  window.console[method](...args);
}

function logSoldOutCrossellProducts() {
  if (!isCrossellDebug) return;
  const soldOutProducts = Array.isArray(window.CROSSSELL_SOLDOUT_PRODUCTS)
    ? window.CROSSSELL_SOLDOUT_PRODUCTS
    : [];
  soldOutProducts.forEach((titleRaw) => {
    const title = String(titleRaw || '').trim();
    if (!title) return;
    crossellDebugConsole('log', `Product '${title}' is sold out.`);
  });
}


function getPopupTransformInit() {
  return isMobile ? "translate(-50%, 100%)" : "translate(-50%, -50%) scale(0.9)";
}

function getPopupTransformFinal() {
  return isMobile ? "translate(-50%, 0%)" : "translate(-50%, -50%) scale(1)";
}

gsap.set(popup, {
  transform: getPopupTransformInit(),
  opacity: 0,
  visibility: "hidden"
});

function showPopup() {
  const overlay = document.querySelector('#cross-popup-overlay');
  const popup = document.querySelector('#cross-popup');

  overlay.classList.add("show");
  popup.classList.add("show");

  // GSAP ScrollTrigger to stick the free shipping bar inside popup scroll
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    trigger: ".free-shipping-bar",
    start: "bottom top+=100",
    endTrigger: ".cross-popup-content",
    end: "bottom bottom",
    scroller: "#cross-popup"
  });

  ScrollTrigger.create({
    trigger: ".free-shipping-bar",
    start: "top +=45px",
    endTrigger: ".cross-popup-collections",
    end: "bottom top",
    markers: false,
    scrub: false,
    onToggle: (self) => {
      const bar = document.querySelector('.free-shipping-bar');
      if (bar) {
        if (self.isActive) {
          bar.classList.add('is-sticky');
        } else {
          bar.classList.remove('is-sticky');
        }
      }
    },
    scroller: "#cross-popup"
  });

  const banner = document.getElementById('cross-popup-banner');
  if (banner) {
    gsap.set(banner, { opacity: 0, y: 0, display: "block" });
    gsap.to(banner, { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" });

    setTimeout(() => {
      gsap.to(banner, {
        opacity: 0,
        y: 0,
        duration: 0.6,
        ease: "power2.inOut",
        onComplete: () => {
          gsap.set(banner, { display: "none" });
        }
      });
    }, 4000);
  }

  gsap.to(popup, {
    duration: 0.6,
    opacity: 1,
    visibility: "visible",
    transform: getPopupTransformFinal(),
    ease: "power2.out",
    onComplete: () => {
      updateFreeShippingBar();
    }
  });

  if (isMobile && document.querySelector(".mask")) {
    gsap.to(".mask", {
      duration: 0.5,
      x: -40,
      ease: "power1.inOut",
      yoyo: true,
      repeat: 1,
      delay: 2
    });
  }
  // updateFreeShippingBar(); // Moved to GSAP onComplete above
}

function closePopup() {
  overlay.classList.remove("show");
  popup.classList.remove("show");

  gsap.to(popup, {
    duration: 0.4,
    opacity: 0,
    visibility: "hidden",
    transform: getPopupTransformInit(),
    ease: "power2.inOut"
  });
}

if (close) close.addEventListener('click', closePopup);
if (overlay) overlay.addEventListener('click', closePopup);
if (cart) cart.addEventListener('click', closePopup);

function updateFreeShippingBar() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const freeShippingThreshold = 7000;
      const cartValueCents = cart.total_price;

      const hasSubscription = cart.items.some(item => item.selling_plan_allocation);

      const popupRoot = document.querySelector('#cross-popup');
      const textEl = popupRoot ? popupRoot.querySelector('.free-shipping-text') : null;
      const barEl = popupRoot ? popupRoot.querySelector('.progress-bar') : null;
      const iconEl = popupRoot ? popupRoot.querySelector('.progress-icon') : null;

      if (!textEl || !barEl || !iconEl) return;

      let barPercentage = Math.min((cartValueCents / freeShippingThreshold) * 100, 100);

      if (hasSubscription && false) {
        barPercentage = 200; // force full bar
      }

      // Update bar width
      barEl.style.width = `${Math.min(barPercentage, 100)}%`;

      if (barPercentage >= 100) {
        textEl.innerHTML = `Shipping is free.*`.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        iconEl.classList.add('free');
      } else {
        const remaining = Math.max(freeShippingThreshold - cartValueCents, 0) / 100;
        const formattedPrice = Shopify.formatMoney(remaining * 100);
        const raw = `Buy for [price] and you have **free shipping** *`;
        const message = raw.replace('[price]', formattedPrice).replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        textEl.innerHTML = message;
        iconEl.classList.remove('free');
      }
    });
}

document.addEventListener('cart:updated', function () {
  showPopup();
});

// Open popup when a product is added to the cart from anywhere
document.addEventListener('product:added', function () {
  showPopup();
});


document.addEventListener("DOMContentLoaded", function () {
  logSoldOutCrossellProducts();

  // Listen to cart drawer refresh and update free shipping bar accordingly
  if (window.cartDrawerElement && typeof window.cartDrawerElement.onRefreshFinish === 'function') {
    const originalOnRefreshFinish = window.cartDrawerElement.onRefreshFinish.bind(window.cartDrawerElement);
    window.cartDrawerElement.onRefreshFinish = function (htmlElement) {
      originalOnRefreshFinish(htmlElement);
      updateFreeShippingBar();
    };
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.add-btn').forEach(button => {
    const stickyCartButton = document.querySelector('.sticky-cart-button .btn');
    if (stickyCartButton) {
      stickyCartButton.addEventListener('click', function () {
        document.getElementById('cross-popup').classList.remove('show');
        document.getElementById('cross-popup-overlay').classList.remove('show');
      });
    }
    button.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      const quantity = 1;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });

        if (response.ok) {
          triggerCrossellAddToCartHaptic();
          crossellDebugConsole('log', 'Product added to cart');
          this.classList.add('added');
          this.textContent = 'Added';
          setTimeout(() => {
            this.classList.remove('added');
            this.textContent = 'Add';
          }, 2000);

          const banner = document.getElementById('cross-popup-banner');
          if (banner) {
            banner.style.display = 'block';
            setTimeout(() => banner.style.display = 'none', 1000);
          }

          // Refresh the free shipping bar
          updateFreeShippingBar();

          // Dispatch custom event to trigger popup
          const productAddedEvent = new Event('product:added');
          document.dispatchEvent(productAddedEvent);

        } else {
          crossellDebugConsole('error', 'Error adding to cart');
        }
      } catch (error) {
        crossellDebugConsole('error', 'Request failed:', error);
      }
    });
  });

  document.querySelectorAll('.add-purchase-button').forEach(button => {
    button.addEventListener('click', function () {
        if (
            !this.disabled &&
            !this.hasAttribute('disabled') &&
            !this.hasAttribute('data-disabled') &&
            this.getAttribute('aria-disabled') !== 'true'
        ) {
        setTimeout(() => {
          showPopup();
        }, 100); // short delay to avoid visual conflict
        } else {
            crossellDebugConsole('log', 'Button is disabled, popup will not show.');
      }
    });
  });
});
